/**
 * Mobile viewport helpers for the public seller intake form (M17).
 */

export const SELLER_INTAKE_MOBILE_MAX_WIDTH_PX = 640;

/** @returns {boolean} */
export function isSellerIntakeMobileViewport() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia(`(max-width: ${SELLER_INTAKE_MOBILE_MAX_WIDTH_PX}px)`).matches;
}

/**
 * Keeps focused inputs visible when the mobile keyboard opens.
 * @param {FocusEvent|{ target?: HTMLElement|null }} event
 */
export function scrollSellerIntakeFieldIntoView(event) {
  if (!isSellerIntakeMobileViewport()) return;
  const target = event?.target;
  if (!target || typeof target.scrollIntoView !== "function") return;

  window.requestAnimationFrame(() => {
    try {
      target.scrollIntoView({ block: "center", behavior: "smooth" });
    } catch {
      target.scrollIntoView();
    }
  });
}

/**
 * @param {FocusEvent|{ target?: HTMLElement|null }} event
 */
export function sellerIntakeMobileFocusHandler(event) {
  scrollSellerIntakeFieldIntoView(event);
}
